import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getSkills } from '../data/skillsData';
import { getSkillIcon } from './SkillIconRenderer';

export default function Skills() {
  const [skillsList, setSkillsList] = useState(getSkills());

  useEffect(() => {
    const handleUpdate = () => {
      setSkillsList(getSkills());
    };
    window.addEventListener('skills_updated', handleUpdate);
    return () => window.removeEventListener('skills_updated', handleUpdate);
  }, []);

  return (
    <section id="skills" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-transparent overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-1/4 -left-32 w-80 h-80 bg-[#4779c4]/5 rounded-full blur-[120px] opacity-20"></div>
        <div className="absolute bottom-1/4 -right-32 w-80 h-80 bg-[#4779c4]/5 rounded-full blur-[120px] opacity-20"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-slate-400 text-sm tracking-widest uppercase mb-2">My Toolbox</p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white font-['Lora']">
            Skills & <span className="text-[#4779c4]">Technologies</span>
          </h2>
        </div>

        {/* Large Single Card for Skills */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="bg-[#2c456b]/20 backdrop-blur-xl rounded-[2.5rem] border border-white/5 p-8 sm:p-10 md:p-12 shadow-2xl relative overflow-hidden group"
        >
          {/* Subtle Inner Glow */}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-[#4779c4]/10 rounded-full blur-[80px] group-hover:bg-[#4779c4]/20 transition-all duration-700"></div>

          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 gap-6 sm:gap-8 md:gap-10">
            {skillsList.map((skill, index) => (
              <motion.div
                key={skill.name + index}
                whileHover={{ y: -5, scale: 1.05 }}
                className="flex flex-col items-center justify-center gap-3 transition-all duration-300"
              >
                <div className="text-2xl sm:text-3xl md:text-4xl drop-shadow-[0_0_10px_rgba(255,255,255,0.05)] hover:drop-shadow-[0_0_15px_rgba(71,121,196,0.4)] transition-all duration-300">
                  {getSkillIcon(skill.iconKey, skill.color)}
                </div>
                <span className="text-slate-400 text-[10px] sm:text-xs font-medium tracking-wide text-center">
                  {skill.name}
                </span>
              </motion.div>
            ))}
          </div>

          {/* Bottom Decorative Element */}
          <div className="mt-12 pt-6 border-t border-white/5 text-center">
            <p className="text-slate-500 text-xs font-['Lora'] italic">
              Continuously learning and expanding my technical expertise...
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}